/* eslint-disable no-tabs */
export const isLLc = () => {
  if (typeof window !== 'undefined') {
    const isLlcEnvironment = window?.location?.host.toLowerCase().includes('hd-qa71.homedepotdev')
			|| window?.location?.host.toLowerCase().includes('hd-qa74.homedepotdev');
    return isLlcEnvironment;
  }
  return true;
};